import type { AgeBand } from '@state/shelf/types'

export const AGE_BANDS: AgeBand[] = ['sameDay', 'upTo3Days', 'upTo7Days', 'older']

export const AGE_BAND_VARIABLE: Record<AgeBand, string> = {
  sameDay: '--color-shelf-age-same-day',
  upTo3Days: '--color-shelf-age-up-to-3-days',
  upTo7Days: '--color-shelf-age-up-to-7-days',
  older: '--color-shelf-age-older',
}
